import { render, staticRenderFns } from "./ProtectedPage.vue?vue&type=template&id=49a90cbe&scoped=true"
import script from "./ProtectedPage.vue?vue&type=script&lang=js"
export * from "./ProtectedPage.vue?vue&type=script&lang=js"
import style0 from "./ProtectedPage.vue?vue&type=style&index=0&id=49a90cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a90cbe",
  null
  
)

export default component.exports